var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewards({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 364.982,
    height: 457.615,
    viewBox: "0 0 364.982 457.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4a14a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d07803"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.879,
    y1: 0.115,
    x2: 0.336,
    y2: 0.92,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#fa8a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa8800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1,
    y1: 0.133,
    x2: 0.151,
    y2: 0.891,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b716b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392d2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fba500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00baef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07c87a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M290.552-70.248,270.294-49.853l-9.488-9.81-5.641,5.68,15.129,15.231,25.9-26.074Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M-13,43H407V-494H-13Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1.075,
    y1: 0.39,
    x2: -0.345,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27a3ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rewards",
    transform: "translate(-20.018 458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M209.575-149l-7.5,15-7.5-15-7.5-60h30Z",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M238.075-75.833A14.817,14.817,0,0,1,223.275-61h-44.4a14.817,14.817,0,0,1-14.8-14.833V-127.75c0-8.2,29.6-22.25,29.6-22.25h14.8s29.6,14.055,29.6,22.25Z",
    fill: "#fac02d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M210.25-150.454V-143H195.381v-7.454l-7.435-59.636h29.739Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M170.921-217.762c-3.762-.962-92.324-24.123-106.985-95.18-6.52-31.644,1.554-49.908,9.487-59.666C83.228-384.691,96.6-389,105.83-389c12.349,0,21.9,3.407,28.386,10.131a29.021,29.021,0,0,1,8.015,19.948c0,11.719-7.918,29.557-29.739,29.557h0a23.9,23.9,0,0,1-10.513-2.721c-7.115-3.742-11.018-10.735-11.018-19.643H105.83c0,4.279,1.658,5.7,3.085,6.463a9.838,9.838,0,0,0,3.584.991c14.148,0,14.869-12.427,14.869-14.909a14.192,14.192,0,0,0-3.978-9.46c-3.591-3.616-9.5-5.449-17.561-5.449-4.476,0-13.9,2.3-20.884,10.891C76.5-352.793,74.27-336.468,78.5-315.968c12.788,62.007,95.224,83.528,96.056,83.729Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M233.223-217.546l-4.453-14.223c.743-.216,74.875-24.317,95.96-84.81,6.461-18.487,6.015-33.106-1.338-43.475-7.1-10.049-19.137-13.687-25.486-13.687-22.051,0-22.3,14.3-22.3,14.909.06,3.437,1.294,14.909,14.869,14.909,3.346-.089,7.435-1.454,7.435-7.454h14.869c0,16.392-13.338,22.364-22.3,22.364-21.828,0-29.739-17.854-29.739-29.818,0-10.31,7.769-29.818,37.173-29.818,11.308,0,27.91,6.232,37.627,19.948,7.07,9.989,13.375,28.014,3.256,57.042C315.191-244.016,236.562-218.6,233.223-217.546Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M237.825-114h-74.5v-14.833c0-8.188,29.8-22.25,29.8-22.25h14.9s29.8,14.062,29.8,22.25Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M275.075-381c0,59.333-15.526,185.417-74.5,185.417s-74.5-126.083-74.5-185.417Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M149.075-61h104v-61h-104Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M164.075-84h74V-99h-74Z",
    fill: "#ffe081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M141.983-200.122l-10.734,7.139-11.981-4.8,3.548,12.354-8.251,9.887,12.893.573,6.943,10.879,4.436-12.089,12.473-3.1-10.144-7.978.816-12.866Z",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M143.118-148.66l-7.667,5.1-8.558-3.425,2.534,8.825-5.894,7.062,9.209.41,4.959,7.771,3.169-8.635,8.91-2.217-7.245-5.7.583-9.19Z",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M75.851-111.075,109.219-97.75l-9.805-34.517,23.072-27.7-35.94-1.512-19.28-30.368L54.813-158.017l-34.8,8.767,28.223,22.235L45.876-91.037Z",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M204.775-8.464H346.094a1.775,1.775,0,0,1,1.775,1.775,1.775,1.775,0,0,1-1.775,1.775H204.775A1.775,1.775,0,0,1,203-6.688,1.775,1.775,0,0,1,204.775-8.464Z",
    fill: "#9a9a9a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M344.629-12.984h-35.9V-69.675h27.182a5.245,5.245,0,0,1,4.872,3.608l8.975,27.315v20.615A5.156,5.156,0,0,1,344.629-12.984Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M308.729-12.984H247.186a5.166,5.166,0,0,1-5.128-5.174V-82.826A5.166,5.166,0,0,1,247.186-88H303.6a5.166,5.166,0,0,1,5.129,5.174Z",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M329.529-.386A12.853,12.853,0,0,0,342.35-13.27a12.853,12.853,0,0,0-12.822-12.884A12.853,12.853,0,0,0,316.707-13.27,12.853,12.853,0,0,0,329.529-.386Z",
    fill: "#37474e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M267.986-.386A12.853,12.853,0,0,0,280.807-13.27a12.853,12.853,0,0,0-12.821-12.884A12.853,12.853,0,0,0,255.164-13.27,12.853,12.853,0,0,0,267.986-.386Z",
    fill: "#37474e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M329.244-7.83a5.141,5.141,0,0,0,5.129-5.154,5.141,5.141,0,0,0-5.129-5.154,5.141,5.141,0,0,0-5.129,5.154A5.141,5.141,0,0,0,329.244-7.83Z",
    fill: "#77909b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M267.7-7.83a5.141,5.141,0,0,0,5.129-5.154,5.141,5.141,0,0,0-5.129-5.154,5.141,5.141,0,0,0-5.129,5.154A5.141,5.141,0,0,0,267.7-7.83Z",
    fill: "#77909b",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M339.754-41.616H321.583a2.459,2.459,0,0,1-2.6-2.609V-62.486a2.459,2.459,0,0,1,2.6-2.609h13.758a2.5,2.5,0,0,1,2.336,1.826L342.091-49.7c0,.261.26.522.26.783v4.7A2.459,2.459,0,0,1,339.754-41.616Z",
    fill: "#37474e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M250.164-75.248h51.029v41.5H250.164Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M207.5-48h27a1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5h-27a1.5,1.5,0,0,1-1.5-1.5A1.5,1.5,0,0,1,207.5-48Z",
    fill: "#9a9a9a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M222.5-39h12a1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5h-12a1.5,1.5,0,0,1-1.5-1.5A1.5,1.5,0,0,1,222.5-39Z",
    fill: "#9a9a9a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M207.5-30h27a1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5h-27a1.5,1.5,0,0,1-1.5-1.5A1.5,1.5,0,0,1,207.5-30Z",
    fill: "#9a9a9a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M368-394H317v74l25.5-7.333L368-320Z",
    fill: "#27a3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M368-384l-1.267.029a13.429,13.429,0,0,0-11.3,6.676l-.716,1.212a3.29,3.29,0,0,1-4.462,1.228l-1.219-.688a13.3,13.3,0,0,0-6.528-1.726,13.3,13.3,0,0,0-6.536,1.728l-1.206.68a3.3,3.3,0,0,1-4.47-1.225l-.717-1.212a13.421,13.421,0,0,0-11.3-6.674L317-384v10.43l1.058.023a3.309,3.309,0,0,1,2.79,1.647l.719,1.212a13.349,13.349,0,0,0,18.118,4.958l1.211-.683a3.26,3.26,0,0,1,3.213,0l1.221.688A13.3,13.3,0,0,0,351.866-364a13.446,13.446,0,0,0,11.577-6.692l.714-1.21a3.314,3.314,0,0,1,2.795-1.648l1.048-.023Z",
    fill: "#058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M383.233-410.324a8.658,8.658,0,0,1,0-8.353l.686-1.246a8.665,8.665,0,0,0-3.107-11.591l-1.217-.738a8.673,8.673,0,0,1-4.178-7.233l-.032-1.424a8.661,8.661,0,0,0-8.484-8.484l-1.424-.031a8.656,8.656,0,0,1-7.233-4.178l-.738-1.217a8.667,8.667,0,0,0-11.591-3.107l-1.246.686a8.658,8.658,0,0,1-8.353,0l-1.243-.683a8.664,8.664,0,0,0-11.588,3.107l-.738,1.217a8.673,8.673,0,0,1-7.233,4.178l-1.424.031a8.661,8.661,0,0,0-8.484,8.484l-.031,1.424a8.657,8.657,0,0,1-4.178,7.233l-1.217.738a8.67,8.67,0,0,0-3.107,11.591l.686,1.246a8.658,8.658,0,0,1,0,8.353l-.683,1.243a8.665,8.665,0,0,0,3.107,11.591l1.217.738a8.673,8.673,0,0,1,4.178,7.233l.031,1.424a8.661,8.661,0,0,0,8.484,8.484l1.424.031a8.657,8.657,0,0,1,7.233,4.178l.738,1.217a8.67,8.67,0,0,0,11.591,3.107l1.246-.686a8.658,8.658,0,0,1,8.353,0l1.246.686a8.665,8.665,0,0,0,11.591-3.107l.738-1.217a8.673,8.673,0,0,1,7.233-4.178l1.424-.031a8.661,8.661,0,0,0,8.484-8.484l.031-1.424a8.657,8.657,0,0,1,4.178-7.233l1.217-.738a8.67,8.67,0,0,0,3.107-11.591Z",
    transform: "translate(0 1)",
    fill: "#27a3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M342.5-383A29.5,29.5,0,0,0,372-412.5,29.5,29.5,0,0,0,342.5-442,29.5,29.5,0,0,0,313-412.5,29.5,29.5,0,0,0,342.5-383Z",
    fill: "#27a3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M342-380c-17.645,0-32-14.578-32-32.5S324.352-445,342-445s32,14.578,32,32.5S359.645-380,342-380Zm0-59.584A26.907,26.907,0,0,0,315.333-412.5,26.907,26.907,0,0,0,342-385.419,26.907,26.907,0,0,0,368.667-412.5,26.907,26.907,0,0,0,342-439.584Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M105.783-442.841a9.747,9.747,0,0,0,2.1,6.053L90.735-412.2a11.384,11.384,0,0,0-2.3-.255,10.056,10.056,0,0,0-7.217,3.077l-12.08-7.082A9.678,9.678,0,0,0,69.7-419.7a10.19,10.19,0,0,0-10.134-10.108A10.19,10.19,0,0,0,49.433-419.7a10.212,10.212,0,0,0,2.1,6.1L34.385-389.064a10.9,10.9,0,0,0-2.251-.2A10.167,10.167,0,0,0,22-379.108,10.157,10.157,0,0,0,32.134-369a10.146,10.146,0,0,0,10.083-10.108A10.331,10.331,0,0,0,39.4-386.19l16.735-23.961a10.762,10.762,0,0,0,3.431.616,10.279,10.279,0,0,0,6.246-2.206L78.559-404.3a13.384,13.384,0,0,0-.2,2,10.19,10.19,0,0,0,10.083,10.159A10.2,10.2,0,0,0,98.567-402.3a10.138,10.138,0,0,0-2.866-7.082l16.786-23.961a9.54,9.54,0,0,0,3.431.611A10.146,10.146,0,0,0,126-442.841,10.157,10.157,0,0,0,115.917-453,10.168,10.168,0,0,0,105.783-442.841Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-10)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.d731645a7bb3f2537a5e518ff2901c7b.svg";
export { ForwardRef as ReactComponent };